<template>
  <footer class="footer-contacts" ref="footerContacts">
    <wrapper>
      <div class="big-title">Обратная связь</div>
      <form action="" class="contacts-form" :class="{ loading }" @submit.prevent="handleSubmit" v-if="!requestResult">
        <div id="captcha-container"></div>
        <div class="form__inputs">
          <div class="input-container" :class="{'border-error': nameError}">
            <!-- <input-text label="Ваше имя" v-model="name" :light="true"
                        @valid="nameValid = true" @invalid="nameValid = false"
            /> -->
            <input-text label="Напишите здесь Ваш вопрос и укажите Вашу контактную информацию для обратной связи" v-model="name" :light="true"  @valid="nameValid = true" @invalid="nameValid = false" />
          </div>
          <!-- <div class="input-container" :class="{'border-error': phoneError}">
            <input-text type="tel" label="Ваш телефон" v-model="phone" placeholder="+7 (___) ___-__-__" :light="true"
                        @valid="phoneValid = true" @invalid="phoneValid = false"
            /> -->
        </div>
        <button class="btn large solid--green">
          <span>Связаться со мной</span>
        </button>


        <div :class="{'border-error': !agree, 'input-container': true, 'contacts-form__check' : true}">
          <input class="contacts-form__checkbox"  type="checkbox"  v-model="agree"  name="agree" @change="onAgree()" id="contacts-form__agree" required checked>
          <label for="contacts-form__agree">Согласен на обработку своих персональных данных – в соответствии<br><a href="/upload/docs/pdf/privacy_policy_www.pdf" target="_blank">с политикой конфиденциальности</a> компании Russ Outdoor</label>
        </div>


        <!--   </div>  -->
        <!--
        <div class="form__captcha">
          <div class="captcha-container">
            <vue-recaptcha :sitekey="recaptcha.key" :size="recaptcha.size" :theme="recaptcha.theme"
                           @render="onRender"
                           @verify="onVerify"
                           @expired="onExpired"/>
          </div>
        </div>
        -->
      </form>

      <div class="request-result" :class="{ show: requestResult !== null }">
        <h3 v-if="requestResult === 'success'">Спасибо! Мы скоро свяжемся с вами.</h3>
        <div class="" v-if="requestResult === 'fail'">
          <h3>{{requestErrorText}}</h3>
          <p><a class="btn  large outline--blue link" @click="reset"><span>Попробовать ещё раз</span></a></p>
        </div>
      </div>
    </wrapper>
  </footer>
</template>

<script>
  // import VueRecaptcha from 'vue-recaptcha';

  export default {
    data() {
      return {
        name: '',
        // phone: '',
        agree: false,
        nameValid: false,
        //phoneValid: false,
        nameError: false,
        //phoneError: false,
        loading: false,
        requestResult: null,
        requestErrorText: null,
        smartCaptcha: {
          key: 'ysc1_xEO2qdf0b0F7Z8VCpnFVeGegMXEXFh6l3rEkLxs762886ad0',
          id: 0,
          rendered: false
        },
        /*
        recaptcha: {
          key: '6LdszmsUAAAAAGI11_H0ieZsLx0c5uYZf2z6QLBl',
          size: 'invisible',
          theme: 'light',
          rendered: false,
        },
        */
      };
    },
    computed: {
      submitEnable() {
        return this.nameValid
                // && this.recaptcha.rendered
                //&& this.phoneValid
                && !this.loading;
      },
    },
    methods: {
      onAgree(){
        console.log('agree');
        console.log(this.agree);
      },
      /*
      onRender(response) {
        // console.log('@captcha: rendered');
        this.recaptcha.rendered = true;
      },

      onVerify(response) {
        // console.log('@captcha: verified: ', response);
      },
      onExpired() {
        console.error('@captcha: expired');
      },
      */
      handleSubmit() {
        if (!window.smartCaptcha) {
          console.error("Ошибка при обработке капчи");
          return;
        }
        
        if (!window.smartCaptcha.rendered) {
          this.smartCaptcha.id = window.smartCaptcha.render('captcha-container', {
            sitekey: this.smartCaptcha.key,
            invisible: true,
            callback: this.captchaCallback,
            hideShield: true
          });
          
          window.smartCaptcha.rendered = true;
        }
        
        let result = window.smartCaptcha.execute(this.smartCaptcha.id);
      },
      reset() {
        this.requestResult = null;
        this.loading = false;
      },
      captchaCallback(token) {
        if (typeof token === "string" && token.length > 0) {
          //this.phoneError = false
          this.nameError = false
          if (!this.nameValid)  this.nameError = true
          //if (!this.phoneValid)   this.phoneError = true


          if (this.submitEnable && !this.loading) {
            this.loading = true;
            //  console.log('@feedback; submiting...');
            this.$store.dispatch('content/sendFeedback',
                    {
                      name: this.name,
                      token: token
                    }
            ).then(response => {
              // console.log('DONE:', response.data);
              this.loading = false;
              if (response.data.success) {
                this.requestResult = 'success';
                this.name = '';
                //this.phone = '';
              } else {
                this.requestErrorText = response.data.errors[0].message;
                this.requestResult = 'fail';
              }
            }, reason => {
              this.loading = false;
              this.requestResult = 'fail';
              this.requestErrorText = reason;
            });
          } else {
            //this.requestResult = 'fail';
            this.requestErrorText = 'Введены неверные значения.';
          }
        } else {
          console.error("Капча не пройдена");
          return false;
        }
      }
    },
    components: {
      //VueRecaptcha
    }
  };
</script>

<style lang="scss" scoped>

  .footer-contacts {
    .big-title {
      margin-bottom: 30px;
    }
    background: $color-blue-6;
    padding: 5rem 0;
    text-align: center;
    @media(max-width: 600px) {
      padding: 35px 0;
    }
    @media (max-width: $media_sm) {
      .big-title {
        margin-bottom: 10px;
      }
    }
  }

  .contacts-form {
    margin: 0 auto;
    width: auto;

    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    @media (max-width: $media_md) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }
    @include ease(all, 0.5s);
    &.loading {
      opacity: 0.5;
    }
    .form__inputs {
      width: 33%;
      @media (max-width: $media_md)  {
        width: 100%;
      }
      display: flex;display: -ms-flexbox;
      flex-flow: row wrap;
      justify-content: space-between; -ms-flex-pack: justify;
      align-items: flex-start;


      @media (max-width: $media_md) {
        .btn {
          width: 100%;
          span {
            font-size: 13px;
          }
        }
      }
    }
    & .input-wrapper {
      margin-bottom: 0;
      margin-top: 0;
      label {
        left: 7px;
        top: 12%;
        font-size: 16px;
      }
    }
    &__check {
      width: 33% !important;
      @media (max-width: $media_md)  {
        width: 100% !important;
      }
      @media (max-width: $media_sm) {
        padding-top: 25px;
      }
      input[type="checkbox"]:checked,
      input[type="checkbox"]:not(:checked) {
        position: absolute;
        left: -9999px;
      }
      input[type="checkbox"]:checked + label,
      input[type="checkbox"]:not(:checked) + label {
        display: inline-block;
        position: relative;
        padding-left: 35px;

        font-size: 11px;
        @media (max-width: 1700px) {
          font-size: 10px;
        }
        text-align: left;
        line-height: 18px;


      }
      input[type="checkbox"]:checked + label:before,
      input[type="checkbox"]:not(:checked) + label:before {
        content: "";
        position: absolute;
        left: 0;
        top: 5px;
        width: 25px;
        height: 25px;
        border: none;
        background-color: #fff;
        border-radius: 0;
        cursor: pointer;
        @media (max-width: $media_sm) {
          top: 0;
        }
      }

      input[type="checkbox"]:checked + label:after,
      input[type="checkbox"]:not(:checked) + label:after {
        content: "";
        position: absolute;
        -webkit-transition: all 0.2s ease;
        -moz-transition: all 0.2s ease;
        -o-transition: all 0.2s ease;
        transition: all 0.2s ease;
        cursor: pointer;
      }

      input[type="checkbox"]:checked + label:after,
      input[type="checkbox"]:not(:checked) + label:after {
        left: 5px;
        top: 11px;
        @media (max-width: $media_sm) {
          top: 5px;
        }
        width: 16px;
        height: 10px;
        border-radius: 1px;
        border-left: 4px solid #0054a2;
        border-bottom: 4px solid #0054a2;
        -webkit-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        transform: rotate(-45deg);
      }
      input[type="checkbox"]:not(:checked) + label:after {
        opacity: 0;
      }

      input[type="checkbox"]:checked + label:after {
        opacity: 1;
      }
      a {
        color: #0054a2;
        text-decoration: none;
      }
    }
    .form__captcha {
      display: none;
      .captcha-container {
        //@include size(70px, 74px);
        //overflow: hidden;
      }
      /deep/ .grecaptcha-badge {
        position: static !important;
        box-shadow: none !important;
        margin: 0 5px 0 0;
        opacity: 0.5;
      }
    }
    .input-container {
      width: 100%;
      padding-bottom: 0;
      @media (max-width: $media_md) {
        margin-bottom: 20px;
      }
      &.border-error {
        .input-wrapper  {
          border: 1px solid red;
        }

      }

      @media (max-width: $media_md) {
        width: 100%;
        .input-wrapper {
          margin: 0px;
        }
      }


    }


  }
  .contacts-form__check.border-error input[type="checkbox"]:not(:checked) + label:before {
    border: 1px solid red;
  }
  .contacts-form .input-wrapper label {
    left: 7px;
    top: 21%;
    font-size: 15px;
    padding-left: 2px;
    padding-right: 2px;
  }


  .request-result {
    @include ease(all, 0.5s);
    transform: translateY(-25px);
    opacity: 0.5;
    &.show {
      transform: none;
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// components/footer/FooterContact.vue